export const employeeRoleCollectionGuard = 'GET /roles/employees';
